import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import { loginAction, selectUser } from "../../../core/auth/authSlice";
import http from "../../../shared/utils/http";
import UserCard, { UserPreviewInfo } from "../../essentials/user-card/UserCard";

import { useSelector } from "react-redux";
import { User } from "../../../shared/models";
import "./TeamList.scss";

export interface TeamListProps {
	setSideMenuVisible: any;
}

const TeamList: React.FC<TeamListProps> = ({ setSideMenuVisible }) => {
	const { userId, actorId } = useSelector(selectUser) as User;

	const [teams, setTeams] = useState<UserPreviewInfo[]>([]);
	const [originalUser, setOriginalUser] = useState<UserPreviewInfo | null>(
		null
	);

	useEffect(() => {
		// Fetch teams managed by the user
		http.get(`/teams/${userId}/teams`).then((res) => {
			setTeams([res]);
		});

		// Fetch original user info if currently acting as a team
		if (userId !== actorId) {
			http.get(`/members/${userId}`).then((res) => {
				setOriginalUser(res);
			});
		}
	}, [userId, actorId]);

	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const switchActor = (newActorId: string) => {
		http.post(`/auth/switch/${newActorId}`).then(() => {
			dispatch(
				loginAction(() => {
					setSideMenuVisible(false);
					window.location.reload();
				})
			);
		});
	};

	return (
		<div className="team-list-container">
			{/* Show original user when acting as a team */}
			{originalUser && userId !== actorId && (
				<div
					className="actor"
					key={originalUser.id}
				>
					<UserCard
						onClick={() => {
							switchActor(userId);
						}}
						darkMode
						size="s"
						userInfo={originalUser}
					/>
					<div
						className="btn switch-button"
						onClick={() => {
							switchActor(userId);
						}}
					>
						switch
					</div>
				</div>
			)}

			{/* Show teams */}
			{teams.length < 1 || typeof teams[0] === "string" ? (
				<div className="no-teams-message">
					<p>You don't manage any teams yet</p>
				</div>
			) : (
				teams.map((team) => {
					if (actorId !== team.id)
						return (
							<div
								className="actor"
								key={team.id}
							>
								<UserCard
									onClick={() => {
										switchActor(team.id);
									}}
									darkMode
									size="s"
									userInfo={team}
								/>

								<div
									className="btn switch-button"
									onClick={() => {
										switchActor(team.id);
									}}
								>
									switch
								</div>
							</div>
						);
				})
			)}
		</div>
	);
};

export default TeamList;
